import React from "react";
import DisplayedDate from "./DisplayedDate";
import WeatherIcon from "./WeatherIcon";
import TemperatureUnits from "./TemperatureUnits";

export default function WeatherInfo(props) {
    return (
      <div className="WeatherInfo">
        <div className="row content">
          <div className="col-sm currentCity">
            <div className="searched-location-info">
              <h4 id="searched-city">{props.data.city}</h4>
              <p>
                <span id="displayd-date">
                  <DisplayedDate date={props.data.date} />
                </span>
                <span id="description" className="text-capitalize">
                  {props.data.description}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="row searchd-current-weather">
          <div className="col-6 current-temp-container">
            <div className="sun-weather-icon">
              <div className="float-left">
                <WeatherIcon
                  code={props.data.icon}
                  alt={props.data.description}
                />
              </div>
            </div>
            <div className="units-wrapped">
              <TemperatureUnits celsius={props.data.temperature} />
            </div>
          </div>
          <div className="col-6 more-details-container">
            <div className="col-sm searched-more-details">
              <ul className="searched-details">
                <li>
                  <img
                    src="https://img.icons8.com/ios/24/000000/wet.png"
                    alt="humidity drops"
                  />
                  <span className="humidity">
                    {" "}
                    Humidity: {props.data.humidity}
                  </span>
                  <span id="humidity"></span>%
                </li>
                <li>
                  <img
                    src="https://img.icons8.com/fluent-systems-regular/24/000000/wind.png"
                    alt="wind blowing"
                  />
                  <span className="wind">
                    {" "}
                    Wind: {Math.round(props.data.wind)}
                  </span>
                  <span id="wind"></span>km/h
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
}